<section class="settings-section">
    <h3>Weergave</h3>
    <p>Kies je thema en weergave-opties. Deze voorkeuren worden bij je account bewaard.</p>
    <app-theme-selector />
</section>

<section class="settings-section" [hidden]="!accountCredits.hasDomains$$()">
    <h3>Credits</h3>
    <p>Het creditsaldo van de domains waarvan je de klantrekening beheert of mag inzien. Kies een domain voor saldo, aankoop en facturen.</p>
    <app-account-credits #accountCredits />
</section>

<section class="settings-section">
    <h3>Privacy</h3>
    <p>Bepaal wat anderen van je zien: of projectgenoten je ledenkaart mogen openen, wie je e-mailadres ziet en of je accountfoto als profielfoto gebruikt wordt.</p>
    <app-peer-visibility-setting />
</section>

<section class="settings-section">
    <h3>Tweestapsverificatie</h3>
    <p>Beveilig je account met een extra inlogstap via een authenticator-app.</p>
    <app-two-factor-setup />
</section>
